import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";
export default function Repeater(props) {
  const [Intro, setPost] = React.useState();

  const styles = {
    holder: {
      display: "block",
      maxWidth: "1368px",
      paddingLeft: "20px",
      paddingRight: "20px",
      position: "relative",
      paddingnTop: "60px",
      paddingBottom: "0px",
      marginTop: "50px",
      marginRight: "auto",
      marginLeft: "auto",
    },
    title: {
      color: "#A0A2CE",
      fontSize: "30px",
      textTransform: "uppercase",
      fontWeight: "400",
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `https://admin.arabian-industries.net/api/api/collections/entry/group_companies/` +
          props.propID +
          `?token=8c25a7a0819fe42e3a0ddb3adc68b1`,
        {
          method: "get",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );
      await response.json().then(function (response) {
        setPost(response);
        //console.log(response);
      });
    };
    fetchData();
  }, [props.catSEND, props.propID]);

  if (!Intro) return;

  return (
    <div style={styles.holder}>
      <React.Fragment>
        {Intro.page_repeater_title ? (
          <h3 style={styles.title}>{Intro.page_repeater_title}</h3>
        ) : (
          <React.Fragment></React.Fragment>
        )}

        {Intro.What_we_do_box &&
          Intro.What_we_do_box.map((item, index) => (
            <React.Fragment key={index}>
              <div className="WWD_Hold">
                <div className="WWD_Hold_L">
                  {item.value.image ? (
                    <img
                      srcSet={process.env.REACT_APP_IMG + item.value.image.path}
                      alt={item.value.title}
                      title={item.value.title}
                      width="600"
                      height="335"
                      loading="lazy"
                      decoding="async"
                      className="WWD_Img"
                    />
                  ) : (
                    <img
                      srcSet={process.env.REACT_APP_IMG + Intro.image_web.path}
                      alt={item.value.title}
                      title={item.value.title}
                      width="600"
                      height="335"
                      loading="lazy"
                      decoding="async"
                      className="WWD_Img"
                    />
                  )}
                </div>
                <div className="WWD_Hold_R">
                  {item.value.logo && (
                    <React.Fragment>
                      <div>
                        <img
                          srcSet={
                            process.env.REACT_APP_IMG + item.value.logo.path
                          }
                          alt={item.value.title}
                          title={item.value.title}
                          width="200"
                          height="200"
                          loading="lazy"
                          decoding="async"
                          className="WWD_logo"
                        />
                      </div>
                    </React.Fragment>
                  )}

                  <h4 className="arabicFont">{item.value.title_ar}</h4>
                  <div
                    className="RepCont"
                    style={{
                      marginTop: "20px",
                      marginBottom: "40px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: item.value.content_ar,
                    }}
                  />

                  {item.value.table && (
                    <React.Fragment>
                      <div
                        style={{
                          marginTop: "20px",
                          marginBottom: "40px",
                        }}
                        className="Table"
                        dangerouslySetInnerHTML={{
                          __html: item.value.table_ar,
                        }}
                      />
                    </React.Fragment>
                  )}

                  <div>
                    {/* BTN A */}
                    {item.value.button_aa && (
                      <Link
                        key={index + `_button_a`}
                        className={
                          item.value.button_aa.butto_name_a_ar
                            ? "WWDLink"
                            : null
                        }
                        to={`${`/ar` + item.value.button_aa.button_url_a}`}
                        title={item.value.button_aa.butto_name_a_ar}
                        state={{
                          from: item.value.button_aa.button_ID_a,
                          catSEND: item.value.button_aa.button_select_a,
                        }}
                      >
                        {item.value.button_aa.butto_name_a_ar}
                      </Link>
                    )}

                    {/* BTN B */}
                    {item.value.button_bb && (
                      <Link
                        key={index + `_button_b`}
                        className={
                          item.value.button_bb.button_name_b_ar
                            ? "WWDLinkB"
                            : null
                        }
                        to={`${`/ar` + item.value.button_bb.button_url_b}`}
                        title={item.value.button_bb.button_name_b_ar}
                        state={{
                          from: item.value.button_bb.button_ID_b,
                          catSEND: item.value.button_bb.button_select_b,
                        }}
                      >
                        {item.value.button_bb.button_name_b_ar}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
      </React.Fragment>
    </div>
  );
}
